import React, { useState } from "react";
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    CardActions,
    Button,
    Menu,
    MenuItem,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import { deleteDoc, doc } from "firebase/firestore";
import { firestore } from "../firebase";

const days = [
    "Mandag",
    "Tirsdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lørdag",
    "Søndag",
];

export default function EntryCard({
    avatar,
    name,
    date,
    children,
    newEntry,
    setNewEntry,
    onSubmit,
    currentUser,
    entryId,
    disabled,
}) {
    const [anchorElNav, setAnchorElNav] = useState(null);

    const handleDeleteEntry = () => {
        deleteDoc(doc(firestore, "guestbook", entryId));
        setAnchorElNav(null);
    };

    return (
        <Card sx={{ mb: 3, width: 1 }}>
            <CardHeader
                avatar={<Avatar src={avatar} aria-label="recipe" />}
                action={
                    !newEntry &&
                    currentUser && (
                        <div>
                            <IconButton
                                aria-label="settings"
                                onClick={(e) =>
                                    setAnchorElNav(e?.currentTarget)
                                }
                            >
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorElNav}
                                open={Boolean(anchorElNav)}
                                onClose={() => setAnchorElNav(null)}
                                MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                }}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                            >
                                <MenuItem onClick={handleDeleteEntry}>
                                    Delete
                                </MenuItem>
                            </Menu>
                        </div>
                    )
                }
                title={name}
                subheader={
                    days[moment(date).weekday() - 1] +
                    " " +
                    moment(date).format("DD. MMM YYYY")
                }
            />
            <CardContent sx={{ py: 0 }}>{children}</CardContent>
            {newEntry && (
                <CardActions sx={{ px: 2, justifyContent: "end" }}>
                    <Button
                        variant="outlined"
                        onClick={() => setNewEntry(false)}
                    >
                        Avbryt
                    </Button>
                    <Button
                        variant="contained"
                        endIcon={<SendIcon />}
                        onClick={onSubmit && onSubmit}
                        disabled={disabled}
                    >
                        Publiser
                    </Button>
                </CardActions>
            )}
        </Card>
    );
}
